import * as types from './linksActionTypes';
import { ILink } from './linksInterfaces';
import { LinkActionKeys as keys } from './linksActionKeys';

export const linkActionCreators = {
  deleteLink: (linkId: number): types.DeleteLink => ({
    payload: { linkId },
    type: keys.DETELTE_LINK
  }),
  deleteLinkFulfilled: (linkId: number): types.DeleteLinkFulfilled => ({
    payload: { linkId },
    type: keys.DETELTE_LINK_FULFILLED
  }),
  fetchLinks: (type: string): types.FetchLinks => ({
    payload: { type },
    type: keys.FETCH_LINKS
  }),
  setLinks: (payload: ILink[]): types.SetLinks => ({
    payload,
    type: keys.SET_LINKS
  }),
  updateLink: (link: ILink): types.UpdateLink => ({
    payload: { link },
    type: keys.UPDATE_LINK
  })
};
